import React, { useEffect, useState } from 'react';
import { NumberFormatter, Divider } from '@mantine/core';
import { THotelOnLineBookingPaymentOrder } from 'libs/data-access/types';
import { ListItem } from './ListItem';
import { ECard, RefundFeeSummary } from 'libs/ui';
import { humanizeText } from 'utils/utility';


interface IProps {
    supplierId: number;
    hotelOnlineBookingPayment: THotelOnLineBookingPaymentOrder | undefined;
    refundCharges: {
        bookingId: number;
        supplierCharge: number | null;
        cancellationCharge: number | null;
        cancellationChargeGst: number | null;
    }[];
};

const SectionTitle = ({ title }: { title: string }) => {
    return (
        <div className="flex items-center gap-2 mt-3">
            <p className="text-navy-blue font-semibold">{title}</p>
            <div className='border-t h-1 grow'></div>
        </div>
    );
};

export default function HotelFareSummary({ ...props }: IProps) {

    const [totalFare, setTotalFare] = useState<number>(0);


    useEffect(() => {
        calculateTotalFare();
    }, []);


    // HANDLER FUNCTIONS
    const calculateTotalFare = () => {

        // console.log("Fare: ", props.hotelOnlineBookingPayment);
        // console.log("Refund Charges: ", props.refundCharges);

        const totalFare = (props.hotelOnlineBookingPayment?.hotelTotalAmount || 0)
            +
            // (props.hotelOnlineBookingPayment?.taxt || 0)                        
            // +
            (props.hotelOnlineBookingPayment?.adminBaseCharge || 0)
            +
            (props.hotelOnlineBookingPayment?.adminServiceCharge || 0)
            +
            (props.hotelOnlineBookingPayment?.adminBookingCharge || 0)
            +
            (props.hotelOnlineBookingPayment?.adminOtherCharge || 0)
            +
            (props.hotelOnlineBookingPayment?.adminTotalGst || 0)
            +
            (props.hotelOnlineBookingPayment?.affiliateBaseCharge || 0)
            +
            (props.hotelOnlineBookingPayment?.affiliateServiceCharge || 0)
            +
            (props.hotelOnlineBookingPayment?.affiliateBookingCharge || 0);

        setTotalFare(+totalFare);

    };


    return (
        <div className="flex flex-col gap-2">
            <div className="flex flex-col gap-3">
                {/* Hotel Fare */}
                <div>
                    <SectionTitle title="Hotel Fare" />
                    <ListItem
                        title="Hotel Fare"
                        value={props.hotelOnlineBookingPayment?.hotelTotalAmount || 0}
                    // value={props.hotelOnlineBookingPayment?.baseCharge || 0}
                    />
                    {/* <ListItem
                        title="Tax & Charges"
                        value={props.hotelOnlineBookingPayment?.totalGst || 0}
                    /> */}
                </div>

                {/* Markup */}
                <div>
                    <SectionTitle title="Admin - My Markup" />
                    <ListItem
                        title="Base Charge"
                        value={props.hotelOnlineBookingPayment?.adminBaseCharge || 0}
                    />
                    <ListItem
                        title="Service Charge"
                        value={props.hotelOnlineBookingPayment?.adminServiceCharge || 0}
                    />
                    <ListItem
                        title="Booking Charge"
                        value={props.hotelOnlineBookingPayment?.adminBookingCharge || 0}
                    />
                </div>

                <div>
                    <SectionTitle title="Affiliate - My Markup" />
                    <ListItem
                        title="Base Charge"
                        value={props.hotelOnlineBookingPayment?.affiliateBaseCharge || 0}
                    />
                    <ListItem
                        title="Service Charge"
                        value={props.hotelOnlineBookingPayment?.affiliateServiceCharge || 0}
                    />
                    <ListItem
                        title="Booking Charge"
                        value={props.hotelOnlineBookingPayment?.affiliateBookingCharge || 0}
                    />
                </div>

                {/* Other Charges */}
                <div>
                    <SectionTitle title="Other Charges" />
                    <ListItem
                        title="Other Charges"
                        value={props.hotelOnlineBookingPayment?.adminOtherCharge || 0}
                    />

                    {/* Discount - only show if there is a discount */}
                    {(props.hotelOnlineBookingPayment?.discount || 0) > 0 && (
                        <ListItem
                            title="Discount"
                            value={-(props.hotelOnlineBookingPayment?.discount || 0)}
                        //   valueClassName="text-green-600"
                        />
                    )}
                </div>

                <div>
                    <SectionTitle title="GST" />
                    <ListItem
                        title="GST"
                        value={props.hotelOnlineBookingPayment?.adminTotalGst || 0}
                    />
                </div>

                {/* Total */}
                <div className="bg-gray-100 py-1 px-2 rounded-md font-semibold text-lg">
                    <ListItem
                        title="Total"
                        showPrefix={true}
                        value={+totalFare.toFixed(2)}
                    />
                </div>
            </div>

            {/* PAYMENT STATUS */}
            {/* {
                props.hotelOnlineBookingPayment?.paymentStatus
                    ?
                    <div className="mt-4 p-2 bg-blue-50 rounded-md text-center">
                        <span className="font-medium">
                            Payment Status: <span className="text-blue-600">{humanizeText(props.hotelOnlineBookingPayment.paymentStatus)}</span>
                        </span>
                    </div>
                    :
                    <></>
            } */}

            {/* Refund Summary */}
            {
                props.refundCharges.some(each => each?.supplierCharge && each?.supplierCharge > 0) &&
                <ECard
                    title="Refund Summary"
                >
                    <RefundFeeSummary
                        service="HOTEL"
                        totalFare={totalFare}
                        refundCharges={props.refundCharges}
                    />
                </ECard>
            }
        </div>
    )
}
